import { DynamicLayout } from '../../formbuilder';
import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

const httpCallBodyFormData: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'httpCall',
      actionParams: {
        headers: {},
        queryStrings: {},
        apiName: '',
        body: {},
      },
      result: {
        '': newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.apiName',
    'action.actionParams.headers.#',
    'action.actionParams.body.#',
    'action.actionParams.queryStrings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.apiName'],
    },
    {
      'API Details': [
        'action.actionParams.body.#',
        'action.actionParams.headers.#',
        'action.actionParams.queryStrings.#',
      ],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    body: {
      dataType: 'keyValue',
      attributes: {
        add: true,
        delete: true,
      },
      label: 'Form Data',
      key: {
        type: 'text',
        label: '',
        placeholder: 'Key',
        validators: {
          required: false,
        },
      },
      value: {
        type: 'text',
        label: '',
        placeholder: 'Value',
        validators: {
          required: false,
        },
      },
    },
  },
};

const httpCallBody: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'httpCall',
      actionParams: {
        headers: {},
        queryStrings: {},
        apiName: '',
        body: '',
      },
      result: {
        '': newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.apiName',
    'action.actionParams.body',
    'action.actionParams.headers.#',
    'action.actionParams.queryStrings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: [
        'action.name',
        'action.description',
        'action.actionParams.apiName',
        'action.actionParams.body',
      ],
    },
    {
      'API Details': ['action.actionParams.headers.#', 'action.actionParams.queryStrings.#'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
};

const httpCallDefault = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'httpCall',
      actionParams: {
        headers: {},
        queryStrings: {},
        apiName: '',
      },
      result: {
        '': newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.apiName',
    'action.actionParams.headers.#',
    'action.actionParams.queryStrings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.apiName'],
    },
    {
      'API Details': ['action.actionParams.headers.#', 'action.actionParams.queryStrings.#'],
    },

    {
      Logic: ['action.result.#'],
    },
  ],
};

export const httpCall: DynamicLayout = {
  json: {
    action: {
      name: '',
      description: '',
      actionType: 'httpCall',
      actionParams: {
        headers: {},
        queryStrings: {},
        apiName: '',
      },
      result: {
        other: newStepValue,
        error: newStepValue,
        timeout: newStepValue,
        'max-connections': newStepValue,
      },
    },
    type: 'action',
  },
  paths: [
    'action.name',
    'action.description',
    'action.actionParams.apiName',
    'action.actionParams.headers.#',
    'action.actionParams.queryStrings.#',
    'action.result.#',
  ],
  groups: [
    {
      Parameters: ['action.name', 'action.description', 'action.actionParams.apiName'],
    },
    {
      'API Details': ['action.actionParams.headers.#', 'action.actionParams.queryStrings.#'],
    },
    {
      Logic: ['action.result.#'],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    headers: {
      dataType: 'keyValue',
      attributes: {
        add: true,
        delete: true,
      },
      label: 'Header',
      key: {
        type: 'text',
        label: '',
        placeholder: 'Key',
        validators: {
          required: false,
        },
      },
      value: {
        type: 'text',
        label: '',
        placeholder: 'Value',
        validators: {
          required: false,
        },
      },
    },
    queryStrings: {
      dataType: 'keyValue',
      attributes: {
        add: true,
        delete: true,
      },
      label: 'Query Parameters',
      key: {
        type: 'text',
        label: '',
        placeholder: 'Key',
        validators: {
          required: false,
        },
      },
      value: {
        type: 'text',
        label: '',
        placeholder: 'Value',
        validators: {
          required: false,
        },
      },
    },
    apiName: {
      type: 'dropdownApi',
      label: 'API Name',
      attributes: {
        value: 'method',
        data: true,
        type: 'api',
      },
      validators: {
        optionSelected: true,
      },
    },
    body: {
      type: 'textarea',
      label: 'Body',
      validators: {
        required: true,
      },
    },
    result: {
      dataType: 'keyValue',
      attributes: {
        add: true,
        delete: true,
      },
      label: 'Result',
      key: {
        type: 'text',
        label: '',
        validators: {
          required: true,
        },
      },
      value: {
        type: 'next',
        label: 'Point to',
      },
    },
  },
  data: {
    apiCall: 'getApis',
    dataPath: 'action.actionParams.apiName',
    apiPath: 'action.actionParams.apiName',
    apiName: {
      PUT: httpCallBody,
      POST: httpCallBody,
      GET: httpCallDefault,
      DELETE: httpCallDefault,
      FORMDATA: httpCallBodyFormData,
    },
    result: {
      value: newStepValue,
    },
  },
};
